import * as ng from 'angular';
import { Countries } from '../configuration';

export class CountryListService {
    public static $inject: string[] = ['$translate'];

    constructor(private $translate: ng.translate.ITranslateService) {}

    public getRawList = (): any => {
        const countryList: any = {};
        Countries.forEach((country) => {
            countryList[country.countryCode.toLowerCase()] = this.$translate.instant(country.tId);
        });
        return countryList;
    };

    public getList = () => {
        return this.formatList(this.getRawList());
    };

    private formatList = (result: any) => {
        return Object.keys(result)
        .map((key) => ({ code: key.toLowerCase(), name: result[key] }));
    };
}
